/* ==========================================================================
   TROPICAL PRESSURE — Shopify Landing Page JavaScript
   Vanilla JS — no framework dependencies
   ========================================================================== */

(function () {
    'use strict';

    /* ---------- Utility ---------- */
    const $ = (sel, root) => (root || document).querySelector(sel);
    const $$ = (sel, root) => [...(root || document).querySelectorAll(sel)];

    /* =======================================================================
       COUNTDOWN TIMER
       Reads data-launch-date="YYYY-MM-DDTHH:MM:SS" from [data-tp-countdown]
       ======================================================================= */
    function initCountdown() {
        const el = $('[data-tp-countdown]');
        if (!el) return;

        const launchISO = el.dataset.launchDate;
        if (!launchISO) return;

        const launchDate = new Date(launchISO);

        const daysEl = $('[data-tp-days]', el);
        const hoursEl = $('[data-tp-hours]', el);
        const minsEl = $('[data-tp-mins]', el);
        const secsEl = $('[data-tp-secs]', el);

        function pad(n) { return String(n).padStart(2, '0'); }

        function tick() {
            const now = new Date();
            let diff = launchDate.getTime() - now.getTime();
            if (diff < 0) diff = 0;

            const d = Math.floor(diff / 86400000);
            const h = Math.floor((diff / 3600000) % 24);
            const m = Math.floor((diff / 60000) % 60);
            const s = Math.floor((diff / 1000) % 60);

            if (daysEl) daysEl.textContent = pad(d);
            if (hoursEl) hoursEl.textContent = pad(h);
            if (minsEl) minsEl.textContent = pad(m);
            if (secsEl) secsEl.textContent = pad(s);
        }

        tick();
        setInterval(tick, 1000);
    }

    /* =======================================================================
       LIVE VIEWER COUNT (simulated)
       ======================================================================= */
    function initViewerCount() {
        const el = $('[data-tp-viewer-count]');
        if (!el) return;

        let count = parseInt(el.dataset.tpViewerCount, 10) || 1240;
        el.textContent = count.toLocaleString();

        setInterval(function () {
            count += Math.floor(Math.random() * 10) - 4;
            if (count < 100) count = 100;
            el.textContent = count.toLocaleString();
        }, 3000);
    }

    /* =======================================================================
       INTERACTIVE POLL
       ======================================================================= */
    function initPoll() {
        const options = $$('[data-tp-poll-option]');
        if (!options.length) return;

        options.forEach(function (btn) {
            btn.addEventListener('click', function () {
                // Mark selected
                options.forEach(function (o) { o.classList.remove('tp-poll__option--selected'); });
                btn.classList.add('tp-poll__option--selected');

                // Show percentages
                const total = options.reduce(function (sum, o) {
                    return sum + (parseInt(o.dataset.votes, 10) || 0);
                }, 0);

                options.forEach(function (o) {
                    const votes = parseInt(o.dataset.votes, 10) || 0;
                    const pct = total > 0 ? Math.round((votes / total) * 100) : 0;
                    const bg = $('[data-tp-poll-bg]', o);
                    const pctEl = $('[data-tp-poll-pct]', o);
                    if (bg) bg.style.width = pct + '%';
                    if (pctEl) {
                        pctEl.textContent = pct + '%';
                        pctEl.style.display = 'inline';
                    }
                });
            });
        });
    }

    /* =======================================================================
       SIGNUP MODAL
       ======================================================================= */
    function initModal() {
        const overlay = $('[data-tp-modal]');
        if (!overlay) return;

        const form = $('[data-tp-modal-form]', overlay);
        const successEl = $('[data-tp-modal-success]', overlay);
        const formEl = $('[data-tp-modal-form-wrap]', overlay);

        // Open triggers
        $$('[data-tp-open-modal]').forEach(function (trigger) {
            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                overlay.classList.add('tp-modal-overlay--open');
                document.body.style.overflow = 'hidden';
                // Reset state when opening
                if (formEl) formEl.style.display = '';
                if (successEl) successEl.style.display = 'none';
            });
        });

        // Close triggers
        $$('[data-tp-close-modal]').forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                overlay.classList.remove('tp-modal-overlay--open');
                document.body.style.overflow = '';
            });
        });

        // Click backdrop to close
        const backdrop = $('[data-tp-modal-backdrop]', overlay);
        if (backdrop) {
            backdrop.addEventListener('click', function () {
                overlay.classList.remove('tp-modal-overlay--open');
                document.body.style.overflow = '';
            });
        }

        // Form submit — HubSpot Forms API
        if (form) {
            form.addEventListener('submit', function (e) {
                e.preventDefault();

                var portalId = form.dataset.hubspotPortal || '243457408';
                var formId = form.dataset.hubspotForm || '4b061334-06c7-4291-a6f1-9eecf0a9e204';
                var emailInput = $('input[type="email"]', form);
                var retailerInput = $('input[name="retailer"]', form);

                if (portalId && formId && emailInput && emailInput.value) {
                    var hubspotUrl = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portalId + '/' + formId;

                    var fields = [
                        { name: 'email', value: emailInput.value }
                    ];

                    if (retailerInput && retailerInput.value) {
                        fields.push({ name: 'favorite_retailer', value: retailerInput.value });
                    }

                    fetch(hubspotUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            fields: fields,
                            context: {
                                pageUri: window.location.href,
                                pageName: document.title
                            }
                        })
                    })
                        .then(function (res) {
                            if (!res.ok) console.warn('HubSpot submission failed:', res.status);
                        })
                        .catch(function (err) {
                            console.warn('HubSpot submission error:', err);
                        });
                }

                // Show success
                setTimeout(function () {
                    if (formEl) formEl.style.display = 'none';
                    if (successEl) successEl.style.display = '';
                }, 600);
            });
        }
    }

    /* =======================================================================
       STICKY CTA — show after scrolling past hero
       ======================================================================= */
    function initStickyCTA() {
        const cta = $('[data-tp-sticky-cta]');
        const hero = $('[data-tp-hero]');
        if (!cta || !hero) return;

        function onScroll() {
            const heroBottom = hero.getBoundingClientRect().bottom;
            if (heroBottom < 0) {
                cta.classList.add('tp-sticky-cta--visible');
            } else {
                cta.classList.remove('tp-sticky-cta--visible');
            }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }

    /* =======================================================================
       SOUND TOGGLE — mute / unmute hero video
       ======================================================================= */
    function initSoundToggle() {
        const btn = $('[data-tp-sound-toggle]');
        if (!btn) return;

        const video = $('.tp-hero__video');
        if (!video) return;

        const iconOff = $('.tp-hero__sound-icon--off', btn);
        const iconOn = $('.tp-hero__sound-icon--on', btn);

        btn.addEventListener('click', function () {
            video.muted = !video.muted;
            if (iconOff) iconOff.style.display = video.muted ? '' : 'none';
            if (iconOn) iconOn.style.display = video.muted ? 'none' : '';
        });
    }

    /* =======================================================================
       SCROLL REVEAL — IntersectionObserver powered fade-in
       Auto-applies to key elements, no markup changes needed
       ======================================================================= */
    function initScrollReveals() {
        if (!('IntersectionObserver' in window)) return;

        // Auto-add tp-reveal class to key section elements
        var revealSelectors = [
            '.tp-showcase__viewer',
            '.tp-showcase__feature',
            '.tp-lifestyle__header',
            '.tp-lifestyle__grid',
            '.tp-story__grid',
            '.tp-story__collage',
            '.tp-partners__heading',
            '.tp-partners__track',
            '.tp-hero__text',
            '.tp-hero__video-wrap',
            '.tp-poll'
        ];

        revealSelectors.forEach(function (sel) {
            $$(sel).forEach(function (el) {
                if (!el.classList.contains('tp-reveal')) {
                    el.classList.add('tp-reveal');
                }
            });
        });

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('tp-revealed');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

        $$('.tp-reveal, .tp-reveal--left, .tp-reveal--right, .tp-reveal--scale').forEach(function (el) {
            observer.observe(el);
        });
    }

    /* =======================================================================
       STAT COUNTERS — animate numbers counting up
       ======================================================================= */
    function initStatCounters() {
        if (!('IntersectionObserver' in window)) return;

        var counters = $$('[data-tp-counter]');
        if (!counters.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);

                var el = entry.target;
                var raw = el.dataset.tpCounter || '0';
                // Parse number and suffix (e.g. "32%" → 32, "%")
                var match = raw.match(/^([\d.]+)(.*)$/);
                if (!match) { el.textContent = raw; return; }

                var target = parseFloat(match[1]);
                var suffix = match[2] || '';
                var isDecimal = match[1].indexOf('.') !== -1;
                var decimals = isDecimal ? (match[1].split('.')[1] || '').length : 0;
                var duration = 1500;
                var startTime = null;

                function animate(timestamp) {
                    if (!startTime) startTime = timestamp;
                    var progress = Math.min((timestamp - startTime) / duration, 1);
                    // Ease out cubic
                    var eased = 1 - Math.pow(1 - progress, 3);
                    var current = eased * target;

                    el.textContent = (isDecimal ? current.toFixed(decimals) : Math.floor(current)) + suffix;

                    if (progress < 1) {
                        requestAnimationFrame(animate);
                    }
                }

                requestAnimationFrame(animate);
            });
        }, { threshold: 0.5 });

        counters.forEach(function (el) { observer.observe(el); });
    }

    /* =======================================================================
       TITLE SHIMMER — add shimmer class to hero title
       ======================================================================= */
    function initTitleShimmer() {
        var title = $('.tp-hero__title');
        if (title) {
            title.classList.add('tp-shimmer');
        }
    }

    /* =======================================================================
       INIT ALL
       ======================================================================= */
    function init() {
        initCountdown();
        initViewerCount();
        initPoll();
        initModal();
        initStickyCTA();
        initSoundToggle();
        initTitleShimmer();
        initScrollReveals();
        initStatCounters();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
